import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

// Move defaultBonuses to module scope
const defaultBonuses = [
  {
    title: 'My "Locations" DLC for Meet Girls Everywhere',
    originalPrice: 69,
    description: "This was once an add-on course that taught you how to specifically approach and pickup girls at the beach, the mall, public transportation, and the gym. But I decided to add it into the main course (it used to cost $69 alone, but now you get it free, because I'm cool like that)."
  },
  {
    title: "Day-Game Case Study",
    originalPrice: 27,
    description: "This is a real story from when I picked up a girl walking around town and how the entire seduction went down, starting from the first meeting and ending in the bedroom (heads up: the story is VERY graphic in detail)."
  },
  {
    title: "Hired-Gun Game Guide",
    originalPrice: 67,
    description: "How to get girls who are working at shops, restaurants, and bars. Getting girls who are working is complicated by the fact that they flirt with you to make sales and get tips, so I give YOU tips that will separate you from every schmuck who tries to hit on the hot barista or bartender and gets you REAL results (because I've done it myself)."
  },
  {
    title: "Schedule Skipper Guide",
    originalPrice: 47,
    description: "Most of the time when you meet girls, you will get their number and set up a date for another day. But occasionally you can get girls out on dates when you first meet them, even if they have other plans. You'll have to be convincing, though. And I'll help you do that."
  },
  {
    title: "Approach Invitation Cheat Sheet",
    originalPrice: 27,
    description: "This is a PDF cheat-sheet from one of the modules in the main course that explains the signs women will give to you when they're interested. You can easily save this on your phone and have with you as you walk around and make it easier to recognize these signals in real time."
  },
  {
    title: "Buzz-Off Signal Cheat Sheet",
    originalPrice: 27,
    description: "Same deal as the approach invitation list, but now for the signals women give when they're definitely not interested, which makes it convenient for you to recognize when they aren't worth your time, so you can focus on girls who already like you."
  }
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '20px',
    backgroundColor: 'transparent',
    textAlign: 'center'
  },
  title: {
    color: props => props.customStyles?.textColor || '#fff',
    fontSize: '32px',
    fontWeight: 700,
    marginBottom: '30px',
    textAlign: 'center',
    fontFamily: '"Roboto Slab", serif'
  },
  bonusItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '20px',
    gap: '12px',
    textAlign: 'left'
  },
  bonusContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flex: 1
  },
  bonusTitle: {
    color: props => props.customStyles?.textColor || '#fff',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: 1.5,
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'baseline',
    '& .price': {
      color: props => props.customStyles?.textColor || '#fff',
      fontWeight: 'normal',
      '& .original': {
        textDecoration: 'line-through',
        marginRight: '8px'
      }
    }
  },
  bonusDescription: {
    color: props => props.customStyles?.textColor || 'rgba(255, 255, 255, 0.9)',
    fontSize: '16px',
    lineHeight: 1.6,
    marginTop: '4px'
  },
  compact: {
    '& $bonusItem': {
      marginBottom: '15px'
    },
    '& $bonusTitle': {
      fontSize: '16px'
    },
    '& $bonusDescription': {
      display: 'none'
    }
  }
}));

// Original BonusSection for the right panel (compact version)
export const BonusSection = ({ bonuses, compact = false, customStyles }) => {
  const classes = useStyles({ customStyles });

  const displayBonuses = bonuses || defaultBonuses;

  return (
    <div className={`${classes.root} ${compact ? classes.compact : ''}`}>
      <Typography variant="h2" className={classes.title}>
        ✅ What You Get
      </Typography>
      
      {displayBonuses.map((bonus, index) => (
        <div key={index} className={classes.bonusItem}>
          <span style={{ color: '#4CAF50', fontSize: '24px', lineHeight: 1 }}>✅</span>
          <div className={classes.bonusContent}>
            <Typography className={classes.bonusTitle}>
              {bonus.title}:
              {bonus.showOriginalPrice && bonus.originalPrice > 0 && (
                <span className="price">
                  <span className="original">${bonus.originalPrice}</span>
                </span>
              )}
            </Typography>
            {!compact && (
              <Typography className={classes.bonusDescription}>
                {bonus.description}
              </Typography>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

// New FullBonusSection for the left panel
const useFullBonusStyles = makeStyles((theme) => ({
  section: {
    width: '100%',
    padding: '40px 20px',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderRadius: '10px',
    marginBottom: '40px'
  },
  title: {
    color: props => props.customStyles?.textColor || '#fff',
    fontSize: '36px',
    fontWeight: 700,
    marginBottom: '30px',
    textAlign: 'center',
    fontFamily: '"Roboto Slab", serif'
  },
  bonusList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px'
  },
  bonusCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    padding: '25px',
    borderRadius: '15px',
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'translateY(-5px)'
    }
  },
  bonusHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '15px'
  },
  bonusTitle: {
    color: props => props.customStyles?.textColor || '#fff',
    fontSize: '24px',
    fontWeight: 600,
    marginBottom: '10px'
  },
  originalPrice: {
    color: '#ff4444',
    textDecoration: 'line-through',
    fontSize: '18px'
  },
  description: {
    color: props => props.customStyles?.textColor || 'rgba(255, 255, 255, 0.9)',
    fontSize: '16px',
    lineHeight: 1.6
  }
}));

export const FullBonusSection = ({ bonuses, customStyles }) => {
  const classes = useFullBonusStyles({ customStyles });
  const displayBonuses = bonuses || defaultBonuses;

  return (
    <div className={classes.section}>
      <Typography variant="h2" className={classes.title}>
        🎁 Exclusive Bonuses Included
      </Typography>
      <div className={classes.bonusList}>
        {displayBonuses.map((bonus, index) => (
          <div key={index} className={classes.bonusCard}>
            <div className={classes.bonusHeader}>
              <Typography variant="h3" className={classes.bonusTitle}>
                {bonus.title}
              </Typography>
              {bonus.showOriginalPrice && bonus.originalPrice > 0 && (
                <Typography className={classes.originalPrice}>
                  Original Price: ${bonus.originalPrice}
                </Typography>
              )}
            </div>
            <Typography className={classes.description}>
              {bonus.description}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
}; 